import {
  FetchCallbackI,
  getResponseWithPagination,
} from "./request/request.interface";
import { sendRequest } from "./request/request.service";
import { ENDPOINTS } from "./endpoints";
import { servicesUtils } from "./utils/services.utils";
import {
  infoFetchGetOpcionPedagogicaI,
  makeOpcionPedagogica,
} from "dtos/opcionPedagogica";

export const getOpcionPedagogica = async (params: any) => {
  const response = await sendRequest<
    getResponseWithPagination<infoFetchGetOpcionPedagogicaI>
  >({
    method: "GET",
    uri: ENDPOINTS.OPCION_PEDAGOGICA,
    params: servicesUtils.removeNullParamsInFilters(params),
  });

  const elementosFormated = response.elementos.map((ctElemento) =>
    makeOpcionPedagogica(ctElemento),
  );
  return {
    ...response,
    elementos: elementosFormated,
  };
};

export const postOpcionPedagogica = async ({
  params,
  images,
}: FetchCallbackI) => {
  const response = await sendRequest<infoFetchGetOpcionPedagogicaI>({
    method: "POST",
    uri: ENDPOINTS.OPCION_PEDAGOGICA,
    images,
    params: servicesUtils.removeNullParamsInFilters(params),
  });
  return makeOpcionPedagogica(response);
};

export const putOpcionPedagogica = async ({
  params,
  images,
}: FetchCallbackI) => {
  const response = await sendRequest<infoFetchGetOpcionPedagogicaI>({
    method: "PUT",
    uri: ENDPOINTS.OPCION_PEDAGOGICA,
    images,
    params: servicesUtils.removeNullParamsInFilters(params),
  });
  return makeOpcionPedagogica(response);
};

export const deleteOpcionPedagogica = async (id: any) => {
  const response = await sendRequest<infoFetchGetOpcionPedagogicaI>({
    method: "DELETE",
    uri: ENDPOINTS.OPCION_PEDAGOGICA + "/" + id,
  });
  return makeOpcionPedagogica(response);
};
